var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coupon"},[_c('fa-layers',[_c('fa',{staticClass:"coupon__icon",attrs:{"icon":"certificate"}}),_c('fa-layers-text',{staticClass:"coupon__value",attrs:{"value":_vm.value,"transform":"right-14"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }